import { Directive } from '@angular/core';
import { NG_VALIDATORS, UntypedFormGroup, Validator } from '@angular/forms';

@Directive({
    selector: '[clearedCheckLayoutFieldsValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: FieldsOverlappingValidatorDirective,
            multi: true,
        },
    ],
    standalone: true,
})
export class FieldsOverlappingValidatorDirective implements Validator {
	validate(control: UntypedFormGroup): { [key: string]: any } | null {
		if (control) {
			const controls = control.controls;
			if (controls.delimitedFile?.value === false) {
				const intervals: Array<any> = [];

				for (let i = 0; i < 4; i++) {
					const fieldStartControl = controls['fieldStart-' + i];
					const fieldLengthControl = controls['fieldLength-' + i];
					if (fieldStartControl && fieldLengthControl) {
						intervals.push([
							parseInt(fieldStartControl.value, 10),
							parseInt(fieldStartControl.value, 10) + parseInt(fieldLengthControl.value, 10),
						]);
					}
				}

				intervals.sort((a, b) => a[0] - b[0]);

				for (let i = 1; i < intervals.length; i++) {
					if (intervals[i - 1][1] > intervals[i][0]) {
						return { fieldsOverlapping: true };
					}
				}
			}
		}

		return null; //Validation passed
	}
}
